import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';

const Register: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [registered, setRegistered] = useState(false);
  const [username, setUsername] = useState('');
  const [mainCharacterName, setMainCharacterName] = useState('');
  const { register } = useAuth();

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username || !email || !password || !confirm || !mainCharacterName.trim()) {
      setError('All fields are required.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    if (!mainCharacterName.trim()) {
      setError('Main character name cannot be blank.');
      return;
    }
    const err = await register(email, password, username, mainCharacterName.trim());
    if (err) {
      setError(err);
      return;
    }
    setRegistered(true);
  };

  return (
    <div className="page-container flex items-center justify-center bg-surface">
      <form onSubmit={handleRegister} className="glass p-8 rounded-xl w-full max-w-md space-y-6">
        <h1 className="text-3xl font-bold text-center mb-4 gradient-text">Register</h1>
        {error && <div className="text-red-400 text-center">{error}</div>}
        {registered ? (
          <div className="text-green-400 text-center font-semibold py-8">
            Registration successful!<br />
            Please check your email and verify your address before logging in.
          </div>
        ) : (
          <>
            <input
              type="text"
              placeholder="Username"
              className="w-full p-3 rounded bg-surface-light border border-border focus:outline-none focus:ring-2 focus:ring-cyan-400"
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Main Character Name *"
              className="w-full p-3 rounded bg-surface-light border border-border focus:outline-none focus:ring-2 focus:ring-cyan-400"
              value={mainCharacterName}
              onChange={e => setMainCharacterName(e.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Email"
              className="w-full p-3 rounded bg-surface-light border border-border focus:outline-none focus:ring-2 focus:ring-cyan-400"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Password"
              className="w-full p-3 rounded bg-surface-light border border-border focus:outline-none focus:ring-2 focus:ring-cyan-400"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <input
              type="password"
              placeholder="Confirm Password"
              className="w-full p-3 rounded bg-surface-light border border-border focus:outline-none focus:ring-2 focus:ring-cyan-400"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
            />
            <button type="submit" className="w-full btn-neon py-2 rounded font-bold mt-2">Register</button>
            <div className="text-center text-text-secondary mt-2">
              Already have an account? <Link to="/login" className="text-cyan-400 hover:underline">Login</Link>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default Register; 